














































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { baseTime } from '@/utils/time'
import { EmptyForm } from '@/utils/emptyForm'
import { cusElForm } from '@/types/form'
@Component
export default class Search extends Vue {
  @Prop() searchSelectPlan!: any[]
  @Prop() searchSubmit!: Function
  /**
    * planId: 选择计划
    * type: 任务类型
    * taskName 任务名称
    * planTime:  计划触发时间
    * instanceId 对象Id
    * taskTime   任务执行时间
    * type    任务名称 目前只有一个类型 webhook
    *     webhook： 1
    *       type: '',
    *
    * executeTimeEnd  任务执行结束
    * triggerTimeEnd 计划触发事件
   */

    form:any = {
      planId: '',
      type: '',
      taskName: '',
      planTime: '',
      instanceId: '',
      taskTime: ''
    }
    // 重置
    resetForm() {
      EmptyForm(this.form)
    }
    /**
     * 查询日志
     */
    vaildSubmit(type: any = null) {
      const { form } = this
      const _form = JSON.parse(JSON.stringify(form))
      const timeType = 'YYYY-MM-DD hh:ss:mm'
      _form.executeTimeStart = _form.taskTime && _form.taskTime !== '' ? baseTime(_form.taskTime[0], timeType) : '' || ''
      _form.executeTimeEnd = _form.taskTime && _form.taskTime !== '' ? baseTime(_form.taskTime[1], timeType) : '' || ''
      _form.triggerTimeStart = _form.planTime && _form.planTime !== '' ? baseTime(_form.planTime[0], timeType) : '' || ''
      _form.triggerTimeEnd = _form.planTime && _form.planTime !== '' ? baseTime(_form.planTime[1], timeType) : '' || ''
      // eslint-disable-next-line no-unused-expressions

      delete _form.planTime
      delete _form.taskTime
      this.searchSubmit(_form)
      // eslint-disable-next-line no-unused-expressions
      type ? delete this.form.objectId : null
    }
    queryLog() {
      this.vaildSubmit()
    }
    mounted() {
      /**
       * 判断是否从子页面跳转进来的
       */

      if (this.$route.query._form) {
        const _form = JSON.parse(JSON.stringify(this.$route.query._form))
        this.form.objectId = _form.objectId
        this.form.planId = _form.planId
        this.form.taskTime = [_form.executeTime, _form.executeTime]
        this.vaildSubmit('first')
      }
      this.vaildSubmit()
    }
}
